import { fieldLevelValidators } from 'utils/validators';
import { chunkArray } from '../../utils/helperMethods';
import { FormElems } from '..';

import { Field } from 'redux-form';

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders fields based on a template, dividing them into groups of two.
 * @param {Object} props - Component properties.
 * @param {string} props.templateId - The ID of the template.
 * @param {Object} props.templateFields - The fields to be rendered based on the template.
 * @param {boolean} props.isViewMode - A flag indicating whether the view mode is active.
 * @returns {JSX.Element|null} - Rendered component or null if no template ID is provided.
 */
const GetTemplateFields = ({ templateId, templateFields, isViewMode }) => {
    // Check if templateId is provided
    if (!templateId) {
        return null; // If no templateId is provided, return null
    }

    // Divide fields into sets of twos
    const groupedFields = chunkArray(templateFields, 2);

    return (
        <>
            {groupedFields.map((group, groupIndex) => (
                <div
                    className="form-section multiCol"
                    key={`group-${groupIndex}`}
                >
                    {group.map((field, fieldIndex) => {
                        const {
                            name,
                            label,
                            type,
                            maxLength,
                            placeholder,
                            max,
                            min,
                            validators,
                        } = field;

                        // Map validators to corresponding functions
                        const validationRule = validators
                            .map(validator => fieldLevelValidators[validator])
                            .filter(
                                validatorFunction =>
                                    validatorFunction !== undefined &&
                                    validatorFunction !== null
                            );

                        return (
                            <div
                                className="form-field"
                                key={`form-field-${fieldIndex}`}
                            >
                                {/* Display label */}
                                <p className="label">{label}</p>

                                {/* Render input field */}
                                <Field
                                    name={`templateInfo.additionalInfo.${name}`}
                                    id={`templateInfo.additionalInfo.${name}`}
                                    type={type}
                                    component={FormElems.Input}
                                    placeholder={placeholder}
                                    max={max}
                                    min={min}
                                    maxLength={maxLength}
                                    validate={
                                        validationRule ? validationRule : []
                                    }
                                    disabled={isViewMode}
                                />
                            </div>
                        );
                    })}
                </div>
            ))}
        </>
    );
};

// Prop type validation
GetTemplateFields.propTypes = {
    templateId: PropTypes.string,
    templateFields: PropTypes.object,
    isViewMode: PropTypes.bool,
};

export default GetTemplateFields;
